<script setup>
import { useToggle } from '@vueuse/core';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const [isOpen, toggle] = useToggle(props.defaultOpen);
</script>

<template>
  <button
    v-bind="$attrs"
    type="button"
    :aria-expanded="isOpen"
    class="flex items-center justify-between w-full gap-4 pt-5 pb-3 text-left border-t cursor-pointer group border-n-weak"
    @click="toggle()"
  >
    <span class="flex flex-col gap-0.5 min-w-0">
      <span class="text-heading-2 text-n-slate-12">
        {{ title }}
      </span>
      <span v-if="description" class="text-label-small text-n-slate-11">
        {{ description }}
      </span>
    </span>
    <span
      class="grid transition-colors rounded-lg size-6 shrink-0 place-items-center text-n-slate-11 group-hover:bg-n-alpha-1 group-hover:text-n-violet-11"
    >
      <Icon
        icon="i-lucide-chevron-down"
        class="transition-transform duration-200 size-4"
        :class="isOpen ? 'rotate-180' : ''"
      />
    </span>
  </button>
  <div v-if="isOpen" class="w-full pt-4 mb-4 space-y-4">
    <slot />
  </div>
</template>
